import { useState, useEffect } from 'react';
import ModalBase from '.';
import { Alert, Input } from '@piggytechng/component-library';
import { OverideInputStyle } from '../../helpers/utils';
import { IoEyeSharp } from 'react-icons/io5';
import { FaEyeSlash } from 'react-icons/fa';
import { ModalGetItActionProps } from '../../types';
import { verifyAdminPassword } from '../../helpers/utils/auth-payload';

const ModalGetItAction = ({
  modalIsOpen,
  setIsOpen,
  title,
  action,
  actionColor = '#F37932',
  isLoading = false,
  activeGetItTab,
}: ModalGetItActionProps) => {
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState('');
  const [formData, setFormData] = useState({
    amount: '',
    reason: '',
    transactionId: '',
  });

  useEffect(() => {
    if (modalIsOpen) {
      setPassword('');
      setFormData({
        amount: '',
        reason: '',
        transactionId: '',
      });
    }
  }, [modalIsOpen]);

  const onButtonClick = async (e: React.MouseEvent) => {
    e.preventDefault();

    if (!formData.amount || !formData.reason) {
      Alert.error('Amount and Reason are required!');
      return;
    }

    if (!formData.transactionId && activeGetItTab !== 'completed') {
      Alert.error('Transaction ID is required!');
      return;
    }

    if (password === '') {
      Alert.error('Please enter your password to proceed!');
      return;
    }

    if (!(await verifyAdminPassword(password))) return;

    action({
      amount: Number(formData.amount.replace(/[^0-9.]/g, '')),
      reason: formData.reason,
      transactionId: formData.transactionId || undefined,
    });
  };

  return (
    <ModalBase modalIsOpen={modalIsOpen} setIsOpen={setIsOpen}>
      <div className="modal-base general success action flex--4">
        <span onClick={() => setIsOpen(false)}>&times;</span>
        <form style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          <h4>{title}</h4>

          <Input
            {...OverideInputStyle}
            label="Amount"
            placeholder="₦500,000"
            height="60px"
            className="user-form-input"
            value={formData.amount}
            onChange={(e) => setFormData({ ...formData, amount: e.target.value })}
          />

          <Input
            {...OverideInputStyle}
            label="Reason"
            placeholder="Wallet adjustment via admin"
            height="60px"
            className="user-form-input"
            value={formData.reason}
            onChange={(e) => setFormData({ ...formData, reason: e.target.value })}
          />

          {activeGetItTab !== 'completed' && (
            <Input
              {...OverideInputStyle}
              label="Transaction ID"
              placeholder="TRF_Ofty6327234812942421242"
              height="60px"
              className="user-form-input"
              value={formData.transactionId}
              onChange={(e) => setFormData({ ...formData, transactionId: e.target.value })}
            />
          )}

          <div className="input-cont flex--2">
            <Input
              {...OverideInputStyle}
              label="Input Password"
              className="user-form-input"
              height="60px"
              placeholder="******"
              type={showPassword ? 'text' : 'password'}
              onChange={(e) => setPassword(e.target.value)}
              id="password"
              name="password"
              value={password}
            />
            <div className="password-icon pointer" onClick={() => setShowPassword(!showPassword)}>
              {showPassword ? <FaEyeSlash size={20} /> : <IoEyeSharp size={20} />}
            </div>
          </div>

          <div className="button-cont flex--2">
            <button type="button" onClick={() => setIsOpen(false)}>
              Cancel
            </button>
            <button onClick={onButtonClick} style={{ backgroundColor: actionColor }} disabled={isLoading}>
              {isLoading ? 'Loading...' : 'Yes'}
            </button>
          </div>
        </form>
      </div>
    </ModalBase>
  );
};

export default ModalGetItAction;
